import { FC } from 'react';
import { Link as RouterLink } from 'react-router';
import {
  ListItem,
  ListItemText,
  Skeleton,
  ListItemButton,
  ListItemAvatar,
  Avatar,
} from '@mui/material';

import { useRouter } from '@cvt/routing';
import { getMatchLabel } from '@shared/helpers/match';

interface Props extends Majors.Major {
  linkTo?: string;
}

export const MajorRow: FC<Props> = ({ linkTo, ...major }) => {
  
  const router = useRouter();

  const _linkTo = linkTo || router.majors.view(major.id).path;

  return (
    <ListItem
      disableGutters
      disablePadding
      divider
    >
      <ListItemButton
        alignItems="center"
        component={RouterLink}
        to={_linkTo}
        sx={{
          opacity: major.match.isIgnored ? 0.5 : undefined,
          backgroundColor: major.match.isIgnored ? 'grey.200' : undefined,
        }}
      >
        <ListItemAvatar>
          <Avatar variant="rounded" src={major.image} alt={major.title} />
        </ListItemAvatar>
        <ListItemText
          primary={major.title}
          secondary={getMatchLabel(major.match)}
          slotProps={{
            root: {
              sx: {
                lineHeight: 1,
              },
            },
            primary: {
              noWrap: true,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              lineHeight: 1,
            },
            secondary: {
              lineHeight: 1,
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export const MajorRowSkeleton: React.FC = () => {

  return (
    <ListItem disableGutters disablePadding divider>
      <ListItemButton disabled>
        <ListItemAvatar>
          <Skeleton variant="rounded" width={40} height={40} />
        </ListItemAvatar>
        <ListItemText
          primary={<Skeleton width="60%" sx={{ maxWidth: 280 }} />}
          secondary={<Skeleton width="30%" />}
          slotProps={{
            root: {
              sx: {
                lineHeight: 1,
              },
            },
            primary: {
              lineHeight: 1,
            },
            secondary: {
              lineHeight: 1,
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
